import React, {useState} from 'react'
import {useSelector} from "react-redux";
import _ from "lodash";

export default function PdfViewer({hotspot, data, onModalClose}) {
  const hostname = useSelector(state => state.hostname)

  const {id,} = hotspot // SO stupid without this useSelector wont update
  const pdfFiles = useSelector(state => state.imageHotspotPdfFiles.filter(pf => pf.image_hotspot_id == id))
  const sortedPdfFiles = _.sortBy(pdfFiles, ["position", "filename", "id"], ["asc", "asc", "asc",])
  const [file, setActivePdfFile] = useState(sortedPdfFiles.length == 1 ? sortedPdfFiles[0] : null)
  const isMobile = navigator && navigator.userAgent && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  const isIpad = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);

  // console.log("----------------------")
  // console.log({hotspot, sortedPdfFiles})
  // console.log("Showing pdf", sortedPdfFiles, "File:", file, "<-")

  if (!sortedPdfFiles) {
    return <div className="alert alert-danger">Missing medial files.</div>
  }
  if (sortedPdfFiles.length == 0) {
    return <div className="alert alert-danger">No PDF files present.</div>
  }
  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
              <style>
                {`
                  @media (min-width: 768px) {
                    .pdf-modal-dialog {
                      max-width: 70vw;
                    }
                  }
                  `}
              </style>
    <div className="modal-dialog pdf-modal-dialog" role="document">
      <div className="modal-content" onClick={(event) => {
        event.stopPropagation()
      }}>
        <div className="modal-header">
          <div className="modal-title">
            {data.title}
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        {file ? (
          <div className="modal-body" style={{maxHeight: "70vh", height: "70vh"}}>
            {sortedPdfFiles.length > 1 &&
            <button className="btn btn-outline-success btn-ueg btn-ueg-styled btn-block mb-1" onClick={() => {
              setActivePdfFile(null)
            }}>
              <i className="fa fa-undo"></i>{" "}
              Back</button>
            }
            {isMobile || isIpad ? (
              <a target="_BLANK" href={file.url}
                 className="btn btn-outline-success btn-ueg btn-ueg-styled btn-block">
                <i className="fa fa-download"></i>{" "}
                Download file
              </a>
            ) : (
              <>
                {hostname == "flavesilhouette20" &&
                  <a target="_BLANK" href={file.url}
                     className="btn btn-outline-success btn-ueg btn-ueg-styled btn-block">
                    <i className="fa fa-download"></i>{" "}
                    Download file
                  </a>
                }
                <iframe style={{width: "100%", height: "100%"}} src={"https://d1pf08eub2a7jl.cloudfront.net/custom/book.html?src=" + file.url + "&title=" + data.tite}>
                  
                </iframe>
                {sortedPdfFiles.length > 1 &&
                  <button className="btn btn-outline-success btn-ueg btn-ueg-styled btn-block mb-1" onClick={() => {
                    setActivePdfFile(null)
                  }}>
                    <i className="fa fa-undo"></i>{" "}
                    Back</button>
                  }
                {/*<embed src={file.url} width="100%" style={{height: "100%"}}/>*/}
              </>
            )}

          </div>) : (

          <div className="modal-body">
            {sortedPdfFiles.map((mf) => {
              return <button className="btn btn-outline-success btn-ueg btn-ueg-styled btn-block" key={mf.id}
                             onClick={() => {
                               setActivePdfFile(mf)
                             }}>
                <div dangerouslySetInnerHTML={{__html: String(mf.description ? mf.description : (mf.title ? mf.title : mf.filename)).replace(".pdf", "")}}/>
              </button>
            })}
          </div>
        )
        }
      </div>
    </div>
  </div>;

}
